// src/world/hiddenObjects.ts — Objetos ocultos y cofres Fase 5
import type { ZoneId } from '../data/gameConfig.js';

export type HiddenObject = {
  id: string;
  zone: ZoneId;
  x: number; y: number;
  itemId: string;
  qty: number;
  respawn: boolean; // false = único
  description?: string;
};

export const HIDDEN_OBJECTS: HiddenObject[] = [
  // Villa Aurelia
  { id:'villa_flores_1', zone:'villa_aurelia', x:3, y:2, itemId:'baya_lumen', qty:1, respawn:false, description:'Entre flores cerca de la entrada norte' },
  { id:'villa_arbol_1', zone:'villa_aurelia', x:27, y:2, itemId:'cristal_lumen', qty:1, respawn:false, description:'Tras el árbol grande este' },
  { id:'villa_detras_casa', zone:'villa_aurelia', x:9, y:5, itemId:'pan_aureliano', qty:1, respawn:true, description:'Detrás de la casa del jugador' },
  // Interiores
  { id:'casa_jugador_mesa', zone:'casa_jugador', x:6, y:5, itemId:'pan_aureliano', qty:1, respawn:false },
  // Ruta Aurelia
  { id:'ruta_fragmento_geoda', zone:'ruta_aurelia', x:14, y:17, itemId:'fragmento_geoda', qty:1, respawn:false, description:'Brilla cerca de la Ruina' },
  { id:'ruta_claro_baya', zone:'ruta_aurelia', x:26, y:21, itemId:'baya_lumen', qty:2, respawn:false, description:'Claro escondido' },
  { id:'ruta_arbol_madre', zone:'ruta_aurelia', x:10, y:19, itemId:'pan_aureliano', qty:1, respawn:false },
  { id:'ruta_puente_cristal', zone:'ruta_aurelia', x:24, y:6, itemId:'cristal_lumen', qty:1, respawn:false },
  { id:'ruta_cueva_pocion', zone:'ruta_aurelia', x:8, y:10, itemId:'pocion_aurea', qty:1, respawn:false },
];

export function objectsInZone(zone: ZoneId): HiddenObject[] {
  return HIDDEN_OBJECTS.filter(o=> o.zone===zone);
}
